import { useState, useEffect, useContext } from "react";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, Tooltip, Badge, Body2, Input, ProgressBar, Spinner } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, Dismiss16Regular, ArrowDownload20Regular, ArrowUpload20Regular, Open20Regular, Settings20Regular, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { useTracking } from "react-tracking";
import { ToastComponent } from "../../../components/toast/toast.component";
import { primaryIcon, secondaryIcon, DynamicBoxingCSS, SubSectionResponsive, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder, warningTheme } from "../../../styles/customStyles";
import { DataTable } from "../../../components/data_table/data_table.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import * as XLSX from 'xlsx';
import { automationConfiguration } from "../../../api/automation/configuration_func";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { AutomationPages } from "../../../components/side_menu/InlineSidenav";

export const All_automation = () => {
	const { trackEvent } = useTracking();
	const navigate = useNavigate();
	const contextValue: any = useContext(GlobalContext);
	const tenantName = contextValue.tenantName;
	var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
	const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
	const [final_data, set_final_data]: any = useState(null);
	const [tableData, setTableData] = useState([]);
	const [leftOpen, setLeftOpen] = useState(false);
	const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
	const [overlayOpen, setOverlayOpen] = useState(false);
	const [searchVal, setSearchVal] = useState("");
	const [totalPages, setTotalPages] = useState(1);
	const [currentPageNo, setCurrentPageNo] = useState(1);
	const [totalRecords, setTotalRecords] = useState(0);
	const [exportData, setExportData] = useState([]);
	const [exportDetails, setExportDetails]: any = useState([]);
	const [allAutomationDetails, setAllAutomationDetails]: any = useState([]);
	const [cardTemplate, setCardTemplate]: any = useState([]);
	const [isRefresh, setRefresh]: any = useState(false);
	const [refreshToast, setRefreshToast]: any = useState(false);
	const [isToast, setIsToast] = useState(false);
	const [tracker, setTracker] = useState(false);
	const [pageName, setPageName] = useState('all-automation')
	const handle = useFullScreenHandle();
	// const [permissions, setPermissions] = useState(['']);
	const { permissions } = usePermissionStore();
	const [loading, setLoading] = useState(true);
	const [overLayDataNew, setOverLayDataNew] = useState<any>({});
	const [selectedValue, setSelectedValue] = useState(0);
	const [isSubTableSelect, setIsSubTableSelect] = useState(false);
	const [overlayOpenNew, setOverlayOpenNew] = useState(false);
	const [csvAutomationList, setCsvAutomationList] = useState<any>([]);
	const [selectedFile, setSelectedFile] = useState<any>();
	const [dataInserted, setDataInserted] = useState<any>(false);
	const [exportBtnClicked, setExportBtnClicked] = useState(false);
	const [importAutomations, setImportAutomations] = useState(false);
	const [isSubmitDisabled, setSubmitDisabled] = useState(false);
	const [isSubmitClicked, setSubmitClicked] = useState(false);
	const [filterArray, setFilterArray] = useState<string[]>([]);
	const [dropDownValue1, setDropDownValue1] = useState<any>();
	const [dropDownValue2, setDropDownValue2] = useState<any>();
	const [isFilter, setIsFilter] = useState(false);
	const [filterMenuOpen, setFilterMenuOpen] = useState(false);
	const [isResetDisabled, setResetDisabled] = useState(true);
	const [error, setError] = useState('');
	const [tableColumnsData, setTableColumnsData] = useState([]);
	const [filterColumnsData, setFilterColumnsData] = useState([]);
	const [errorMessage, setErrorMessage] = useState<String>('');

	const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
	const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
	const [uniqueType, setUniqueType] = useState<string[]>([]);

	const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
	const [statusOptions, setStatusOptions] = useState<any[]>([]);
	const [typeOptions, setTypeOptions] = useState<any[]>([]);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isImportProgressLoading, setIsImportProgressLoading] = useState(false);
	const [isCommonToast, setIsCommonToast] = useState(false);
	const [message, setMessage] = useState<{ type: 'success' | 'error' | 'warning' | ''; text: string } | null>(null);
	const [isProgressLoading, setIsProgressLoading] = useState(false);

	useEffect(() => {
		setCreatedBy(uniqueCreatedBy?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
		setStatusOptions(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
		setTypeOptions(uniqueType?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
		console.log("Unique type:", uniqueType);
	}, [uniqueCreatedBy, uniqueStatus, uniqueType]);

	console.log('permissions ----> ', permissions);

	const handleFilterArray = (): any => {
		const value1 = dropDownValue1;
		const value2 = dropDownValue2;
		// if(value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
		const result = value1 + " : " + value2;
		setFilterArray([...filterArray, result])
		setIsFilter(true);
		setLoading(true);
		setDropDownValue1('');
		setDropDownValue2('');
		// }
		if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
			setErrorMessage(`${dropDownValue1} is already filtered.`);
			return;
		} else {
			setErrorMessage(''); // Clear the message if no issue
		}
	}

	const handleCloseFilter = (index: any): any => {
		const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
		setFilterArray(updatedArray);
		setLoading(true);
	}

	useEffect(() => {
		if (filterArray.length > 0) {
			setResetDisabled(false)
		}
		else {
			setResetDisabled(true)
		}
	}, [filterArray])
	const insertAutomationData = () => {
		console.log('automation insert clicked')
		setImportAutomations(true);
	};

	const inputChange = (e: any) => {
		const enteredValue = e.target.value;
		console.log("entered value", enteredValue)
		let name = e.target.name;
		const regexS = /^[A-Za-z ]*$/;
		const regexSN = /^[A-Za-z0-9_ -]*$/;
		const regexN = /^[0-9]*$/;
		if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
			setErrorMessage(`${dropDownValue1} is already filtered.`);
			console.log("*****************************")
			return;
		} else {
			setErrorMessage(''); // Clear the message if no issue
		}
		if (name === 'filter' && dropDownValue1 === ("Name") || dropDownValue1 === ("Description") || dropDownValue1 === "Status") {
			if (regexSN.test(enteredValue)) {
				setDropDownValue2(enteredValue);
			}
		}
		// if (name === 'filter' && dropDownValue1 === ("Created by")) {
		// 	if (regexS.test(enteredValue)) {
		// 		setDropDownValue2(enteredValue);
		// 	}
		// }
	}

	let exportToExcel = async () => {
		const ws = XLSX.utils.json_to_sheet(exportData);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
		XLSX.writeFile(wb, `all_automations_list.csv`);
	};

	var tableColumns: any[] = [];
	var filterColumns: any[] = [];
	useEffect(() => {
		contextValue?.tableColumnsData?.Automation?.All_Automation?.forEach((val) => {
			if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
				if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
					tableColumns[val.priority] = ({
						key: val.key,
						label:
							<>
								<Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
									<StackItem>
									<Body1Strong>
										{`${val.name}`}
										<Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
										<Info16Filled style={{ marginLeft: 5, verticalAlign: "text-bottom" }} {...timezoneInfo} />
										</Tooltip>
									</Body1Strong>
									</StackItem>
								</Stack>
							</>
					});
				} else {
					tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
				}
			}

			if (val.display.filter.toLocaleLowerCase() === "yes") {
				filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
			}
		});

		setTableColumnsData(tableColumns);
		setFilterColumnsData(filterColumns);

		contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Automation?.All_Automation?.filter((val) => val.priority >= 0));

		contextValue.setManageViewPageDetails({ module: "Automation", page: "All_Automation" });
	}, [contextValue.tableColumnsData]);

	//data table column name code starts here
	// var columns = [
	// 	{ key: "name", label: <Body1Strong> Name </Body1Strong> },
	// 	{ key: "type", label: <Body1Strong> Type </Body1Strong> },
	// 	{ key: "description", label: <Body1Strong> Description </Body1Strong> },
	// 	{ key: "created_by", label: <Body1Strong> Created By </Body1Strong> },
	// 	{ key: "created_on", label: <Body1Strong> Created On (UTC)</Body1Strong> },
	// 	{ key: "created_on_timezoned", label: <Body1Strong> Created On ({formattedTimeZone})</Body1Strong> },
	// 	{ key: "last_modified", label: <Body1Strong> Last Modified (UTC) </Body1Strong> },
	// 	{ key: "last_modified_timezoned", label: <Body1Strong> Last Modified ({formattedTimeZone}) </Body1Strong> },
	// 	{ key: "status", label: <Body1Strong> Status </Body1Strong> },
	// ];
	// //data table column name code ends here
	// var columns1 = [
	// 	{ key: "name", label: <Caption1> Name </Caption1> },
	// 	{ key: "description", label: <Caption1> Description </Caption1> },
	// 	{ key: "created_by", label: <Caption1> Created by </Caption1> },
	// 	{ key: "created_on", label: <Caption1> Created On </Caption1> },
	// 	{ key: "last_modified", label: <Caption1> Last Modified </Caption1> },
	// 	{ key: "status", label: <Caption1> Status </Caption1> },
	// ];

	// overflow set contents code starts here
	var overFlowComponent = {
		data:
			<>
				<StackItem>
					<Button disabled={loading} shape="circular" appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setRefresh(true); setSearchVal(""); setLoading(true); }}>
						<Stack tokens={{ childrenGap: 5 }} horizontal>
							<StackItem>{loading? <ArrowClockwise20Regular {...secondaryIcon} />: <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
							<StackItem> <Caption1> Refresh </Caption1> </StackItem>
						</Stack>
					</Button>
				</StackItem>
				{permissions.includes("all") || permissions.includes("allAutomation_Fullaccess") || permissions.includes("allAutomation_Fullaccess") ?
					<StackItem>
						{/* <CSVLink id="csv-export-link" data={exportData} filename="configurationlist.csv"> */}
						<Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" /*onClick={() => {userActivity('Export', `{"summary":"Automation list exported"}`); }}*/ onClick={() => { setExportBtnClicked(true); }}>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
								<StackItem> <Caption1> Export </Caption1> </StackItem>
							</Stack>
						</Button>
						{/* </CSVLink> */}
					</StackItem>
					:
					<StackItem>
						<Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
							<Button  shape="circular" appearance="subtle" size="small" disabled>
								<Stack tokens={{ childrenGap: 5 }} horizontal>
									<StackItem><Text></Text></StackItem>
									<StackItem>
										<Stack tokens={{ childrenGap: 5 }} horizontal>
											<StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
											<StackItem><Caption1> Export </Caption1></StackItem>
										</Stack>
									</StackItem>
								</Stack>
							</Button>
						</Tooltip>
					</StackItem>
				}

				<StackItem><Divider vertical /></StackItem>

				{permissions.includes("all") || permissions.includes("allAutomation_Fullaccess") || permissions.includes("allAutomation_Fullaccess") ?
					<StackItem>
						{/* <CSVLink id="csv-export-link" data={exportData} filename="configurationlist.csv"> */}
						<Button disabled={loading || tableData.length === 0} shape="circular" appearance="subtle" size="small" onClick={() => {
							setOverlayOpenNew(true);
							setSelectedValue(0);
							setCsvAutomationList([]);
							setDataInserted(false);
							setMessage({ type: "", text: "" })
							setSubmitClicked(false);
						}}>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem> {loading || tableData.length === 0? <ArrowUpload20Regular  {...secondaryIcon} /> :<ArrowUpload20Regular  {...primaryIcon} /> } </StackItem>
								<StackItem> <Caption1> Import </Caption1> </StackItem>
							</Stack>
						</Button>
						{/* </CSVLink> */}
					</StackItem>
					:
					<StackItem>
						<Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
							<Button shape="circular" appearance="subtle" size="small" disabled>
								<Stack tokens={{ childrenGap: 5 }} horizontal>
									<StackItem><Text></Text></StackItem>
									<StackItem>
										<Stack tokens={{ childrenGap: 5 }} horizontal>
											<StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
											<StackItem><Caption1> Import </Caption1></StackItem>
										</Stack>
									</StackItem>
								</Stack>
							</Button>
						</Tooltip>
					</StackItem>
				}

				<StackItem>
					<Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
						<Stack tokens={{ childrenGap: 5 }} horizontal>
							<StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
							<StackItem> <Caption1> Manage View </Caption1> </StackItem>
						</Stack>
					</Button>
				</StackItem>
				<StackItem grow shrink>
					<Stack horizontalAlign="end">
						<StackItem grow shrink>
							<FullScreenButton handle={handle} />
						</StackItem>
					</Stack>
				</StackItem>
			</>
		,
	};
	// overflow set contents code ends here

	var menuLists: any = [];
	var tempExportData: any = [];

	// data table values append code ends here

	var timer: any;
	const searchHandle = (data: any) => {
		timer = clearTimeout(timer);

		timer = setTimeout(() => {
			setSearchVal(data.target.value);
		}, 500);
	};
	var tempTableData: any = [];



	useEffect(() => {
		var tempExportData: any = [];
		// var status = '';
		console.log('exportDetails ->', exportDetails)
		exportDetails?.length > 0 && exportDetails.map((val: any) => {
			/*if(val.status == 'not attached'){
			  status = 'Not attached';  
			}else{
			  var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));
	  
			  if(curStatus.length == 0){
				status = 'Enabled for other tenant';  
			  }else{
				curStatus = curStatus[0]?.split(":")[1];
			  
				if(curStatus == 'all'){
				  status = 'Enabled for All Devices';
				}else{
				  status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
				}
			  }
			}*/
			// let jsonValue = JSON.stringify(val.varValues, null, 2).replace(/,/g, '\\,');
			if(val.types === 'automation' || val.types === 'selfhelp' || val.types === 'proactive'){

				tempExportData.push({
					'ID': val.id,
					'DartID': val.dartid,
					'Name': val.automationName,
					'Type': val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1),
					'Description': val.description,
					'category': val.category,
					'subCategory': val.subCategory,
					'jsonValue': val.jsonValue,
					'varValues': val.varValues,
					// 'varValues': JSON.stringify(`'${val.varValues}'`),
					// 'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
					// 'Created On': val.createdOn != null ? convertToExcelFormat(val.createdOn) : '-',
					// 'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
					// 'Status': status,
				});
			}
		});

		setExportData(tempExportData);
		console.log('exportBtnClicked clicked: ' + exportBtnClicked);
		// tempExportData && exportToExcel()
	}, [exportDetails]);

	useEffect(() => {
		console.log('exportData : ' + exportData);
		exportData.length > 0 && exportToExcel();
	}, [exportData]);

	// useEffect(() => {
	//   //roles and permissions
	//   async function loadRoute() {
	//     console.log("role:-",sessionStorage.getItem('role'))
	//     const role = sessionStorage.getItem('role');

	//     try {
	//       const [routeAllowed, permissions] = await shouldLoadRoute(role);

	//       if (routeAllowed) {
	//         console.log("permission===",permissions);

	//         setPermissions(permissions)
	//       } else {
	//         console.log('Route is not allowed.');
	//       }
	//     } catch (error) {
	//       console.error('Error loading route:', error);
	//     }
	//   }

	//   loadRoute();
	// }, []);

	useEffect(() => {
		if (!overlayOpenNew) {
			setError('')
			setSubmitDisabled(true); // disable sumbit button when overlay will get closes.
		}
	}, [overlayOpenNew]);

	useEffect(() => {
		if (final_data !== undefined && final_data !== null) {
			const newUniqueCreatedBy: string[] = [];
			const newUniqueStatus: string[] = [];
			const newUniqueType: string[] = [];

			final_data?.forEach((val: any) => {
				if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
					newUniqueCreatedBy.push(val.createdBy);
				}
				if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
					newUniqueStatus.push(val.status);
				}
				if (val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1) && val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1).trim() !== "-" && !newUniqueType.includes(val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1))) {
					newUniqueType.push(val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1));
				}
			});

			setUniqueCreatedBy(newUniqueCreatedBy);
			setUniqueStatus(newUniqueStatus);
			setUniqueType(newUniqueType);
			console.log("Unique Created By:", newUniqueCreatedBy);
		} else {
			setUniqueCreatedBy([]);
			setUniqueStatus([]);
			setUniqueType([]);
		}
	}, [final_data]);

	useEffect(() => {
		var status = ''
		console.log("final_data=", final_data);

		final_data !== undefined && final_data !== null
			? final_data?.map((val: any, i: any) => {
				if (val.status == 'not attached') {
					status = 'Not attached';
				} else {
					var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

					if (curStatus.length == 0) {
						status = 'Enabled for other tenant';
					} else {
						curStatus = curStatus[0]?.split(":")[1];

						if (curStatus == 'all') {
							status = 'Enabled for All Devices';
						} else {
							status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
						}
					}
				}

				tempTableData.push({
					checkbox: "hide",
					name: { label: <Caption1>{val.automationName}</Caption1> },
					type: { label: <Caption1> {val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1)} </Caption1>, status: "" },
					description: { label: <Caption1> {val.description}</Caption1> },
					created_by: { label: <Caption1> {val.createdBy} </Caption1> },
					created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
					created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
					last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
					last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
					status: { label: <Caption1>{status} </Caption1> },
				});
			}) : (tempTableData = []);
		tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

		setTimeout(() => {
			final_data !== undefined && final_data !== null && setLoading(false);

			if (isRefresh) {
				setRefresh(false);
				setRefreshToast(true);
				setTimeout(() => {
					setRefreshToast(false);
				}, 3000);
			}

		}, 500);
	}, [final_data])


	useEffect(() => {
		console.log("tracked page");
		// !tracker && setTracker(true);
		// trackUserActivity({pageName: 'All automation', moduleName: "Automation", action: 'view', time: Math.floor(Date.now() / 1000)});
	}, []);

	//dropdown data
	var dropdownData = [
		{
			key: "op_1",
			label:
				<Body1Strong
					onClick={() => {
						setSelectedValue(1);
						setIsSubTableSelect(true)
						contextValue.selectedRowIdInTable.length > 0 && contextValue.setSelectedRowIdInTable([]);
					}}
				>
					Choose devices manually
				</Body1Strong>
		},
		{ key: "op_2", label: <Body1Strong onClick={() => setSelectedValue(2)}> Upload a CSV containing the Devices </Body1Strong> }
	];
	// const handleUpload = () => { const fileUpload = document.getElementById('fileUpload'); fileUpload?.click(); };
	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const selectedFile = event.target.files?.[0];
		console.log('selectedFile - ', selectedFile?.name)
		setSelectedFile(selectedFile);
		if (!selectedFile) return;

		// Check if the file is a CSV by MIME type or extension
		if (selectedFile.type !== "text/csv" && !selectedFile.name.endsWith(".csv")) {
			setError("Please upload a CSV file");
			return;
		} else {
			setError(""); // Clear error if the file is valid
			setSubmitDisabled(false);
		}

		const reader = new FileReader();
		reader.onload = async (e: ProgressEvent<FileReader>) => {
			if (!e.target?.result) return;

			const data = new Uint8Array(e.target.result as ArrayBuffer);
			const workbook = XLSX.read(data, { type: 'array' });

			// Assuming you want to process the first sheet
			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const jsonData: (string | number)[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

			// Define required headers and their order
			const requiredHeaders = [
				'ID',
				'DartID',
				'Name',
				'Type',
				'Description',
				'category',
				'subCategory',
				'jsonValue',
				'varValues',
				
			];

			 // Get headers from the first row and normalize them
        const headers = (jsonData[0] as string[]).map(header => 
            header?.toString().trim().toLowerCase()
        );

        // Find missing headers
        const missingHeaders = requiredHeaders.filter(
            requiredHeader => !headers.includes(requiredHeader.toLowerCase())
        );

        if (missingHeaders.length > 0) {
            setError(`Missing required columns: ${missingHeaders.join(', ')}`);
            setSubmitDisabled(true);
            return;
        }

        // Get index of Type column
        const typeColumnIdx = headers.findIndex(
            header => header === 'type'
        );
		// Filter to only include rows with type "Automation"
		// const filteredData = jsonData.filter((row, index) => {
		// 	if (index === 0) return true; // Keep headers
		// 	return row[typeColumnIdx]?.toString().toLowerCase() === 'automation' || 'selfhelp';
		// });
		const filteredData = jsonData.filter((row, index) => {
			if (index === 0) return true; // Keep headers
			
			// Check if row exists and has any values
			if (!row || Object.values(row).every(val => val === null || val === undefined || val === '')) {
			  return false;
			}
			
			// Check type only if it exists
			const typeValue = row[typeColumnIdx]?.toString().toLowerCase();
			return typeValue.toLowerCase() === 'automation' || typeValue.toLowerCase() === 'selfhelp' || typeValue.toLowerCase() === 'proactive' || typeValue.toLowerCase() === 'autoheal';
		  });

		if (filteredData.length <= 1) { // If only headers remain
			setError("No rows with type 'Automation' found in the file");
			setSubmitDisabled(true);
			return;
		}
	
			 // Create a mapping of required headers to their column indices
			 const columnMapping = requiredHeaders.reduce((mapping, header) => {
				const index = headers.findIndex(h => h === header.toLowerCase());
				mapping[header] = index;
				return mapping;
			}, {} as Record<string, number>);
	
			// Reorder the data according to required header sequence
			const updatedData = filteredData.map((row, rowIndex) => {
				if (rowIndex === 0) return requiredHeaders; // Use required headers as first row
				
				return requiredHeaders.map(header => 
					row[columnMapping[header]]
				);
			});

			console.log('Imported Data - ', updatedData); // Process and display the updated data
			console.log('Imported Data type - ', typeof updatedData); // Process and display the updated data
			setCsvAutomationList(updatedData)
		};

		reader.readAsArrayBuffer(selectedFile);
	};
	console.log("setSubmitDisabled=====", isSubmitDisabled);
	console.log("setOverlayOpenNew===", overlayOpenNew)
	useEffect(() => {
		setOverLayDataNew({
			size: "medium",
			isTabs: false,

			headerTitle:
				(
					<>
						<Title3>
							{'Import Automations'}
						</Title3>
					</>
				),

			bodyData:
				(
					<>
					<Stack>{isImportProgressLoading && <ProgressBar />}</Stack>
						<Stack tokens={{ childrenGap: 10 }} horizontal>
							<StackItem grow shrink>
								<Stack tokens={{ childrenGap: 10 }} horizontal>
									<StackItem grow shrink>
										<Stack tokens={{ childrenGap: 20 }} horizontalAlign="start">
											<StackItem>
												{<><Stack className={isImportProgressLoading ? 'disabled-opacity' : ''} verticalAlign="center" tokens={{ childrenGap: 10 }}>
														<Stack tokens={{ childrenGap: 10 }}>
															<StackItem><Text></Text></StackItem>
															<Body1> Importing automation ensures consistency, efficiency and reduces manual effort by replicating workflows across instances. </Body1> 
															{/* <Body1> You can choose devices from the same site or different ones to create groups. </Body1> */}
															<StackItem><Text></Text></StackItem>
															<FluentProvider theme={warningTheme}>
																<Text> Import for Automation, Self-help/Proactive, and Auto-heal only. </Text>
															</FluentProvider>
															<StackItem><Text></Text></StackItem>
															<Body1Strong> Steps to create the automations </Body1Strong> 
															<Stack tokens={{ padding: "0px, 0px, 0px, 15px"}}>
																<ol>
																	<li> <Body1> Export the list of automations you want to import. </Body1> </li>
																	<li>  <Body1> Review the automations in the CSV file, keep only the ones you want to import, and delete the rest. </Body1>  </li>
																	<li>  <Body1> Upload the .csv file </Body1>  </li>
																</ol>
															</Stack>
															<StackItem>
																{/* <FileUploadComponent setDeviceList={setCsvAutomationList} /> */}
																{/* <Button shape="circular" appearance='secondary' size='small' onClick={handleUpload}> Select a file </Button> */}
																<input /*style={{"display": "none"}} */ type="file" onChange={handleFileChange} accept='.csv' id="fileUpload" />
																{error && <p style={{ color: 'red' }}>{error}</p>}
																{/* {selectedFile?.length > 0 && <Text> File selected: {selectedFile} </Text>} */}
																{/* <button onClick={ handleFileUpload}>Upload</button> */}
															</StackItem>
														</Stack>
													</Stack>
												</>
												}
											</StackItem>
										</Stack>
									</StackItem>
								</Stack>
							</StackItem>
						</Stack>
					</>
				),

			footerData:
				(
					<>
						{
							<Button
								appearance="primary"
								disabled={
									!selectedFile || Boolean(error) || isSubmitDisabled
								}
								onClick={() => { insertAutomationData(); setSubmitDisabled(true); setSubmitClicked(true); setIsImportProgressLoading(true);}}
							>
								{isSubmitClicked! ? (
                              	<Stack horizontal horizontalAlign="center" verticalAlign="center" tokens={{ childrenGap: 8 }}>
									<Spinner delay={1000} size="extra-tiny" />
									<Body1Strong>Inserting</Body1Strong>
								</Stack>
								) : (
								<Body1Strong>Submit</Body1Strong>
								)}
							</Button>
						}
						{(dataInserted) && (<Badge appearance="ghost" color="success"> <Body2> Automations has been inserted successfully!</Body2> </Badge>)}
					</>
				)
		});
	}, [selectedFile, csvAutomationList, dataInserted, overlayOpen, isImportProgressLoading,error,isSubmitClicked, isSubmitDisabled]);
	//overlay code ends here
	// let [finalHeader, ...finalRows] = final_data;

	// // Function to check and modify automationName if duplicate exists
	// function modifyAutomationName(automationName:any, types:any) {
	// //   let modifiedName = automationName;
	// //   let counter = 1;
	// //   const existingNames = final_data
	// //     .filter((row: any[]) => row[1] === automationName && row[2] === types)
	// //     .map((row: any[]) => row[1]);
	// // console.log('existingNames of automation - ',existingNames)
	// //   while (existingNames.includes(modifiedName)) {
	// //     modifiedName = `${automationName}_${counter}`;
	// //     counter += 1;
	// //   }

	// //   return modifiedName;
	// }
	// Function to check and modify automationName if duplicate exists
	// function modifyAutomationName(automationName: any, types: any) {
	//   let modifiedName = automationName;
	//   let counter = 1;

	//   // Collect all existing automationNames and their types from final_data and rows
	//   const existingNames = new Set([
	//     ...final_data.core_AutomationJSON.map((item: { automationName: any; types: any; }) => `${item.automationName}|${item.types}`),
	//     ...csvAutomationList.map((row: any[]) => `${row[1]}|${row[2]}`) // Assuming automationName is at index 1 and types at index 2 in rows
	//   ]);

	//   // If modifiedName already exists with the same type, append counter until unique
	//   while (existingNames.has(`${modifiedName}|${types}`)) {
	//     modifiedName = `${automationName}_${counter}`;
	//     counter++;
	//   }

	//   return modifiedName;
	// }


	useEffect(() => {
		console.log('final_data - > ', final_data)
		if (csvAutomationList.length > 0) {
			// validDevicesList=[];
			// inValidDevicesList=[];
			// alldAutomationList=[];
			console.log('csvAutomationList ->', csvAutomationList)
			// var newArray = csvAutomationList[1];
			// console.log('newArray ->',typeof newArray);
			// // Extract header and rows
			// const [header, ...rows] = csvAutomationList;
			// console.log('header ',header)
			// // Loop through each row and call the mutate function
			// for (const row of rows) {
			//   let [
			//     dartid, 
			//     automationName, 
			//     types, 
			//     description, 
			//     category, 
			//     subCategory, 
			//     jsonValue, 
			//     varValues
			//   ] = row;

			//   automationName = modifyAutomationName(automationName, types);        
			//   addAutomation( automationName, description, jsonValue, types, dartid, category, varValues, subCategory)
			//   console.log("extracting data - ",automationName, description, jsonValue, types, dartid, category, varValues, subCategory)
			// }
			//   const objects = newArray.map((item: any[]) => ( 
			//     console.log('items in automation list type - ', typeof item),
			//     console.log('items in automation list ', item)
			//   // item.map((items: any) =>(
			//   //   console.log("items in automation list  --- ",items[0])
			//   // ))
			// ));  
			// addAutomation(objects);
			// devicesOfTenant?.core_Census.map((val: any) => { alldDevicesList.push(val.host); });

			// csvAutomationList.map((val: any) => {
			//   var automationName=val.replace(/[\r\n]/g, '');
			//   console.log('automationName - ',automationName);
			// });

			// validDevicesList.length > 0 ? setSelectedTableData(validDevicesList) : setSelectedTableData([]);

			// contextValue.setSelectedRowIdInSubTable(validDevicesList);
		}
	}, [csvAutomationList]);

	useEffect(() => {
		const pageNo = (currentPageNo - 1) * 50;
		console.log('currentPageNo: ' + currentPageNo)
		console.log('pageNo: ' + pageNo)
		const props: any = {
			selectedRowIdInTable: contextValue.selectedRowIdInTable,
			tenant: tenantName,
			data: final_data,
			func: set_final_data,
			searchVal: searchVal,
			pageNo: pageNo,
			setTotalPages: setTotalPages,
			setTotalRecords: setTotalRecords,
			dropDownValue1: dropDownValue1,
			isRefresh: isRefresh,
			setRefresh: setRefresh,
			setIsToast: setIsToast,
			setRefreshToast: setRefreshToast,
			dropdownData: dropdownData,
			selectedValue: selectedValue,
			setOverlayOpen: setOverlayOpen,
			exportBtnClicked: exportBtnClicked,
			setExportBtnClicked: setExportBtnClicked,
			setExportDetails: setExportDetails,
			setAllAutomationDetails: setAllAutomationDetails,
			setSelectedRowIdInTable: contextValue.setSelectedRowIdInTable,
			setLoading: setLoading,
			pageName: pageName,
			setImportAutomations: setImportAutomations,
			csvAutomationList: csvAutomationList,
			setCsvAutomationList: setCsvAutomationList,
			setDataInserted: setDataInserted,
			setOverlayOpenNew: setOverlayOpenNew,
			setCurrentPageNo: setCurrentPageNo,
			setSearchVal: setSearchVal,
			importAutomations: importAutomations,
			setSubmitDisabled: setSubmitDisabled,
			isFilter: isFilter,
			setIsFilter: setIsFilter,
			dropDownValue2: dropDownValue2,
			filterArray: filterArray,
			setIsDisabled: setIsDisabled,
			setIsImportProgressLoading: setIsImportProgressLoading,
			setMessage:setMessage,
			setIsCommonToast:setIsCommonToast
		};



		console.log('searchVal.length > 0: ', searchVal.length);
		console.log('exportBtnClicked: ', exportBtnClicked);
		console.log('isRefresh: ', isRefresh);
		console.log(' final_data: ', final_data == null);
		console.log(' importAutomations: ', importAutomations);

		(searchVal.length > 0 || exportBtnClicked || isRefresh || final_data == null || importAutomations || currentPageNo) && automationConfiguration(props);

	}, [isRefresh, searchVal, currentPageNo, selectedValue, exportBtnClicked, importAutomations, filterArray, isFilter]);

	return (
		<>
			<FullScreen handle={handle} className="fullScreenBackgroundColor">
				<StackItem grow shrink style={BreadcrumbsBorder}>
					<Stack tokens={{ childrenGap: 10 }} horizontal>
						<StackItem grow shrink>
							<Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
								<StackItem><Text></Text></StackItem>
								<StackItem grow shrink>
									<Breadcrumbs
										items={[
											{ name: "Automate", link: "/home" },
											{ name: "Automation", link: "#" },
											{ name: "All Automations", link: "#" }
										]}
									/>
								</StackItem>
							</Stack>
						</StackItem>
					</Stack>
				</StackItem>
				<Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
					<StackItem style={DynamicBoxingCSS}>
						<StackItem style={DynamicBoxingCSS}>
							{/* pages code starts here */}
							<Stack style={DynamicBoxingCSS}>
								<FluentProvider style={parentHome} theme={dashboardTheme}>
									<Stack style={parentHome} horizontal>
										{/* SPACING BETWEEN INLINE AND PAGE */}
										<SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomationPages(`All${" "}Automations`)} />
										<StackItem style={DynamicBoxingCSS}>
											<Stack style={parentHome} tokens={{ childrenGap: 10 }}>
												<StackItem>
													<OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
													<Divider />
												</StackItem>
												<StackItem>
													<StackItem style={wraperStyle}>
														<Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
															<Stack horizontal tokens={{ childrenGap: 10 }}>
																<StackItem>
																	<SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading} />
																</StackItem>
																<StackItem>
																	<MenuDropdown open={filterMenuOpen} btn={
																		<MenuButton disabled={loading} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
																			<Stack tokens={{ childrenGap: 5 }} horizontal>
																				{loading ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
																				<Body1> Filter </Body1>
																			</Stack>
																		</MenuButton>
																	} itemVal={<><Body1Strong> Add a Filter </Body1Strong>
																		<Divider />
																		<MenuList>
																			<Stack tokens={{ childrenGap: 5 }}>
																				<StackItem> <Text></Text> </StackItem>
																				<StackItem> <Caption1> Filter </Caption1> </StackItem>
																				<DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
																				<StackItem> <Divider /> </StackItem>
																				<StackItem> <Caption1> Value </Caption1> </StackItem>
																				{(dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />))}
																				{(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Status") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />))}
																				{dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
																				{dropDownValue1 === "Type" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={typeOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
																				<StackItem> <Divider /> </StackItem>
																				<Stack tokens={{ childrenGap: 10 }} horizontal>
																					<StackItem>
																						<Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
																							disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
																							<Caption1> Apply </Caption1>
																						</Button>
																					</StackItem>

																					<StackItem>
																						<Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
																							<Caption1> Cancel </Caption1>
																						</Button>
																					</StackItem>
																				</Stack>
																			</Stack>
																		</MenuList>
																	</>} />
																</StackItem>
																<StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true); }}>
																	<Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
																		<Stack tokens={{ childrenGap: 5 }} horizontal>
																			<StackItem> <FilterDismiss20Filled /> </StackItem>
																			<StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
																		</Stack>
																	</Button>
																</StackItem>
															</Stack>
															{(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
														</Stack>
														<Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
															<StackItem>
																{filterArray.length > 0 && (
																	<Stack horizontal wrap>
																		{filterArray.map((item, index) => (
																			<Button shape="circular" size="small">
																				<Stack tokens={{ childrenGap: 5 }} horizontal>
																					<StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
																					<StackItem>
																						<Stack tokens={{ childrenGap: 1 }}>
																							<StackItem><Text></Text></StackItem>
																							<StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
																						</Stack>
																					</StackItem>
																				</Stack>
																			</Button>
																		))}
																	</Stack>
																)}
															</StackItem>

															<StackItem disableShrink>
																{(tableData.length > 0 && !loading) && (
																	totalRecords > 0 &&
																	<Caption1>
																		Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
																	</Caption1>
																)}
															</StackItem>
														</Stack>
													</StackItem>

													{/* <Stack horizontal enableScopedSelectors horizontalAlign="space-between"> <StackItem> <Caption1>  Showing {((currentPageNo-1) * 10) + 1} to {(currentPageNo * 10) > totalRecords ? totalRecords : (currentPageNo * 10)} of {totalRecords} Records </Caption1> </StackItem> <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo}/> </StackItem> </Stack> */}
												</StackItem>
												{/* <Stack id="lorem" horizontal wrap> {cardTemplate} </Stack> */}
												{/* <All_automation_func 
													set_final_data={set_final_data} 
													searchVal={searchVal} 
													isRefresh={isRefresh} 
													setRefresh={setIsRefresh} 
													setRefreshToast={setRefreshToast} 
													/> */}

												{/* <Configuration_func pageName={pageName} data={final_data} func={set_final_data} setTotalRecords={setTotalRecords} setTotalPages={setTotalPages} pageNo={(currentPageNo - 1) * 50} searchVal={searchVal} isRefresh={isRefresh}  setRefresh={setRefresh} setRefreshToast={setRefreshToast} setExportDetails={setExportDetails} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked}/> */}

												{/* <DataTable tableData={tableData} columns={columns} ></DataTable> */}
												{loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

												{
													refreshToast &&
													<ToastComponent
														setmessagebar={setIsToast}
														isToastEnabled={refreshToast}
														toastIntent="success"
														position="top-end"
														title="Success"
														message={'Automation Refreshed'}
														footer=""
													/>
												}
											</Stack>
										</StackItem>
									</Stack>
								</FluentProvider>
							</Stack>
							{/* <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData="Census"/> */}
							<OverLay
								overlayopen={overlayOpenNew}
								setOverlayOpen={setOverlayOpenNew}
								overlayData={overLayDataNew}
							/>
							{isCommonToast && (
								<ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent={message?.type} position="top-end" title={message?.type.charAt(0).toUpperCase() + message?.type.slice(1)} message={message?.text} footer="" />
							)}
						</StackItem>
					</StackItem>
					<StackItem><Text></Text></StackItem>
				</Stack>
			</FullScreen>
		</>
	);
};
